export const geocodeByAddress = (address, callback) => {
  const geocoder = new window.google.maps.Geocoder();
  const OK = window.google.maps.GeocoderStatus.OK;

  return new Promise((resolve, reject) => {
    geocoder.geocode({address}, (results, status) => {
      if (status !== OK) {

        // TODO: Remove callback support in the next major version.
        if (callback) {
          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
          callback({status}, null, results);
          return;
        }

        reject(status);
      }

      // TODO: Remove callback support in the next major version.
      if (callback) {
        const latLng = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
        callback(null, latLng, results);
      }

      resolve(results);
    });
  });
};

// eslint-disable-next-line arrow-parens
export const getLatLng = (result) => new Promise((resolve, reject) => {
  try {
    const latLng = {
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng()
    };
    resolve(latLng);
  } catch (e) {
    reject(e);
  }
});

// eslint-disable-next-line arrow-parens
export const getAddressObject = (results) => new Promise((resolve, reject) => {
  try {
    const {
      address_components: addressComponents,
      place_id: placeId,
      geometry,
    } = results[0];

    let streetNumber = '';
    let streetName = '';
    let city;
    let state;
    let zip;
    let county;
    let country;
    let neighborhood;

    addressComponents.forEach((component) => {
      component.types.forEach((type) => {
        if (type === 'street_number') {
          streetNumber = component.long_name;
        } else if (type === 'route') {
          streetName = component.short_name;
        } else if (type === 'locality' || type === 'sublocality') {
          city = component.long_name;
        } else if (type === 'administrative_area_level_1') {
          state = component.short_name;
        } else if (type === 'administrative_area_level_2') {
          county = component.short_name;
        } else if (type === 'postal_code') {
          zip = component.long_name;
        } else if (type === 'country') {
          country = component.long_name;
        } else if (type === 'neighborhood') {
          neighborhood = component.long_name;
        }
      });
    });

    const latLng = {
      lat: geometry.location.lat(),
      lng: geometry.location.lng(),
    };

    resolve({
      street: `${streetNumber} ${streetName}`,
      city: city || neighborhood,
      state,
      zip,
      country,
      latLng,
      county,
      placeId,
    });
  } catch (e) {
    reject(e);
  }
});

export const getZipCode = (googlePlace) => {
  try {
    let zip;

    for (let i = 0; i < googlePlace.address_components.length; i++) {
      for (let k = 0; k < googlePlace.address_components[i].types.length; k++) {
        if (googlePlace.address_components[i].types[k] === 'postal_code') { zip = googlePlace.address_components[i].long_name; }
      }
    }
    return zip;
  } catch (e) {
    console.log(e);
  }
};

export const geocodeByPlaceId = (placeId, callback) => {
  const geocoder = new window.google.maps.Geocoder();
  const OK = window.google.maps.GeocoderStatus.OK;

  return new Promise((resolve, reject) => {
    geocoder.geocode({placeId}, (results, status) => {
      if (status !== OK) {

        // TODO: Remove callback support in the next major version.
        if (callback) {
          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
          callback({status}, null, results);
          return;
        }

        reject(status);
      }

      // TODO: Remove callback support in the next major version.
      if (callback) {
        const latLng = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        console.warn('Deprecated: Passing a callback to geocodeByPlaceId is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
        callback(null, latLng, results);
      }

      resolve(results);
    });
  });
};



// WEBPACK FOOTER //
// ./src/components/AddressAutocomplete/utils.js